import React from 'react';
import styled from 'styled-components';
const Container = styled.div `
  display: inline-block;
  position: relative;
  vertical-align: middle;
  width: 48px;
  height: 16px;
`;
const getCommonLoadingStyles = (color, interval) => `
  position: absolute;
  width: 6px;
  height: 6px;
  background-color: ${color};
  -webkit-border-radius: 5px;
  border-radius: 5px;
  background-clip: padding-box;
  -webkit-animation: growDot 1s linear ${interval} infinite;
  -moz-animation: growDot 1s linear ${interval} infinite;
  -ms-animation: growDot 1s linear ${interval} infinite;
  -o-animation: growDot 1s linear ${interval} infinite;
  animation: growDot 1s linear ${interval} infinite; 
`;
const LoaderDots = styled.div `
  top: 5px;
  left: 21px;
  ${props => getCommonLoadingStyles(props.color, '.15s')}

  &::before {
    content: "";
    top: 0;
    left: -15px;
    ${props => getCommonLoadingStyles(props.color, '0s')}
  }

  &::after {
    content: "";
    top: 0;
    left: 15px;
    ${props => getCommonLoadingStyles(props.color, '.3s')}
  }

  @-webkit-keyframes growDot {
    0% {
      -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=70)";
      filter: alpha(opacity=(70));
      opacity: 0.7;
      -webkit-box-shadow: 0px 0px 0px 0px ${props => props.color};
      box-shadow: 0px 0px 0px 0px ${props => props.color};
    }
    25% {
      -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
      filter: alpha(opacity=(100));
      opacity: 1;
      -webkit-box-shadow: 0px 0px 0px 4px ${props => props.color};
      box-shadow: 0px 0px 0px 4px ${props => props.color};
    }
    50% {
      -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=70)";
      filter: alpha(opacity=(70));
      opacity: 0.7;
      -webkit-box-shadow: 0px 0px 0px 0px ${props => props.color};
      box-shadow: 0px 0px 0px 0px ${props => props.color};
    }
    100% {
      -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=60)";
      filter: alpha(opacity=(60));
      opacity: 0.6;
      -webkit-box-shadow: 0px 0px 0px 0px ${props => props.color};
      box-shadow: 0px 0px 0px 0px ${props => props.color};
    }
}
@keyframes growDot {
    0% {
      -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=70)";
      filter: alpha(opacity=(70));
      opacity: 0.7;
      -webkit-box-shadow: 0px 0px 0px 0px ${props => props.color};
      box-shadow: 0px 0px 0px 0px ${props => props.color};
    }
    25% {
      -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
      filter: alpha(opacity=(100));
      opacity: 1;
      -webkit-box-shadow: 0px 0px 0px 4px ${props => props.color};
      box-shadow: 0px 0px 0px 4px ${props => props.color};
    }
    50% {
      -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=70)";
      filter: alpha(opacity=(70));
      opacity: 0.7;
      -webkit-box-shadow: 0px 0px 0px 0px ${props => props.color};
      box-shadow: 0px 0px 0px 0px ${props => props.color};
    }
    100% {
      -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=60)";
      filter: alpha(opacity=(60));
      opacity: 0.6;
      -webkit-box-shadow: 0px 0px 0px 0px ${props => props.color};
      box-shadow: 0px 0px 0px 0px ${props => props.color};
    }
  }

`;
export default function CssLoadingDots(color) {
    return (React.createElement(Container, null,
        React.createElement(LoaderDots, { color: color || "#ccd3ff" })));
}
